import type { ReactNode } from "react";

import { Page, type PageProps } from "@/design-system/Page";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

type DocumentPageProps = PageProps & {
  tabTitle: string;
};

export function DocumentPage({ tabTitle, ...pageProps }: DocumentPageProps): ReactNode {
  useDocumentTitle(tabTitle);

  return <Page {...pageProps} />;
}
